import { createAction } from 'redux-actions';

export const showAction = createAction('@@tooltip/SHOW_TOOLTIP');
export const hideAction = createAction('@@tooltip/HIDE_TOOLTIP');

export const clearAction = createAction('@@tooltip/CLEAR_TOOLTIPS');